import { createReducer, on } from "@ngrx/store";
import { userPoliciesInitialState } from "../initial-states/user-policies.state";
import { addUserPolicy, deleteUserPolicy, loadUserPolicies, loadUserPoliciesFailed, loadUserPoliciesSuccess, deletePoliciesTemplatesUsing, resetUserPolicies, updateUserPolicy, updatePoliciesTemplatesUsing, addPoliciesTemplatesUsing } from "../actions/user-policies.action";
import { Policy, PolicySaveScopes } from "src/app/models/user-policies.model";
import { UserProduct } from "src/app/models/user-products.model";

export const UserPoliciesReducer = createReducer(userPoliciesInitialState,

	// The reducer runs when a dispatch 'loadUserPolicies' was triggered
	// The only thing we need to do here is set loading to true
	on(loadUserPolicies,
		(state) => {
			return { ...state, policies: { ...state.policies, loading: true } };
		}
	),

	// The reducer runs when a dispatch 'loadUserPoliciesSuccess' was triggered
	// Here we need to set the loading to false, set the value of 'loadedOnce' and add the value of the policys for the specific type
	on(loadUserPoliciesSuccess,
		(state, { userPolicies }) => {
			return { ...state, policies: { ...state.policies, loading: false, loadedOnce: true, value: userPolicies } };
		}
	),

	// The reducer runs when a dispatch 'loadUserPoliciesFailed' was triggered
	// Here we need to set the state to the initial one, set the value of 'loadedOnce' and add the value of the error action result into the store
	on(loadUserPoliciesFailed,
		(state, { error }) => {
			return { ...state, policies: { ...state.policies, loading: false, loadedOnce: false, error: error } };
		}
	),

	// The reducer runs when a dispatch 'loadUserPoliciesFailed' was triggered
	// Here we need to set the state to the initial one, set the value of 'loadedOnce' and add the value of the error action result into the store
	on(addUserPolicy,
		(state, { userPolicy }) => {
			return { ...state, policies: { ...state.policies, value: [...state.policies.value, userPolicy] } };
		}
	),


	// The reducer runs when a dispatch 'loadUserPoliciesFailed' was triggered
	// Here we need to set the state to the initial one, set the value of 'loadedOnce' and add the value of the error action result into the store
	on(updateUserPolicy,
		(state, { userPolicy }) => {
			return { ...state, policies: { ...state.policies, value: updatePolicy(state.policies.value, userPolicy) } };
		}
	),


	// The reducer runs when a dispatch 'loadUserPoliciesFailed' was triggered
	// Here we need to set the state to the initial one, set the value of 'loadedOnce' and add the value of the error action result into the store
	on(deleteUserPolicy,
		(state, { policyId }) => {
			return { ...state, policies: { ...state.policies, value: deletePolicy(state.policies.value, policyId) } };
		}
	),

	// The reducer runs when a dispatch 'deleteTemplatesUsing' was triggered
	// Here we need to set the state to the initial one, set the value of 'loadedOnce' and add the value of the error action result into the store
	on(deletePoliciesTemplatesUsing,
		(state, { templateIds }) => {
			return { ...state, policies: { ...state.policies, value: deleteTemplatesUsingByTemplateIds(state.policies.value, templateIds) } };
		}
	),

	// The reducer runs when a dispatch 'updateTemplatesUsing' was triggered
	on(updatePoliciesTemplatesUsing,
		(state, { userProduct }) => {
			return { ...state, policies: { ...state.policies, value: updateTemplatesUsingBasedOnTemplate(state.policies.value, userProduct) } };
		}
	),

	// The reducer runs when a dispatch 'addPoliciesTemplatesUsing' was triggered
	on(addPoliciesTemplatesUsing,
		(state, { userProduct }) => {
			return { ...state, policies: { ...state.policies, value: addTemplatesUsingBasedOnTemplate(state.policies.value, userProduct) } };
		}
	),

	// The reducer runs when a dispatch 'resetUserPolicies' was triggered
	// Here we need to reset the state to the initial one
	on(resetUserPolicies,
		(state) => {
			return { ...state, policies: { ...state.policies, loading: false, loadedOnce: false, value: [], error: undefined } };
		}
	),
)

function updatePolicy(currentPolicies: Policy[], updatedPolicy: Policy): Policy[] {
	const policyToUpdateIndex = currentPolicies.findIndex(x => x.id === updatedPolicy.id);
	currentPolicies[policyToUpdateIndex] = updatedPolicy

	return currentPolicies;
}

function deletePolicy(currentPolicies: Policy[], policyId: string) {
	const policyToBeDeletedIndex = currentPolicies.findIndex(x => x.id === policyId);
	currentPolicies.splice(policyToBeDeletedIndex, 1)

	return currentPolicies;
}

function deleteTemplatesUsingByTemplateIds(policies: Policy[], templateIds: string[]): Policy[] {
	for (const policy of policies) {
		policy.templatesUsing = policy.templatesUsing?.filter(x => !templateIds.includes(x));
		policy.templates = policy.templates?.filter(x => !templateIds.includes(x.id));
	}

	return policies;
}

function updateTemplatesUsingBasedOnTemplate(policies: Policy[], userProduct: UserProduct): Policy[] {
	for (const policy of policies) {
		if (policy.saveScope === PolicySaveScopes.List && policy.templatesUsing) {
			if (policy.templatesUsing.includes(userProduct.id)) {
				if (userProduct.templatePolicies?.find(x => x.id === policy.id) === undefined) {
					policy.templatesUsing = policy.templatesUsing.filter(x => x !== userProduct.id)
					policy.templates = policy.templates?.filter(x => x.id !== userProduct.id)
				}
			} else {
				if (userProduct.templatePolicies?.find(x => x.id === policy.id)) {
					policy.templatesUsing?.push(userProduct.id)
					policy.templates?.push(userProduct)
				}
			}
		}
	}

	return policies;
}

function addTemplatesUsingBasedOnTemplate(policies: Policy[], template: UserProduct){
	if(template.templatePolicies){
		for (const templatePolicy of template.templatePolicies){
			const policyToUpdate = policies.find(x => x.id === templatePolicy.id)
			if(policyToUpdate?.templatesUsing && !policyToUpdate.templatesUsing.includes(template.id)){
				policyToUpdate.templatesUsing.push(template.id)
				policyToUpdate.templates?.push(template)
			}
		}
	}
	return policies
}
